import React from 'react';

const EmailInput = (props) => {
    return (
        <input {...props} />
    );
}

export default EmailInput;
